module.exports = __webpack_public_path__ + "static/Virtual Kitchen Co-f03939734e4c74e33a73a8fe662fa2ab.jpg";